import { VALIDATION_PATTERNS } from './shared/validation/validation.constants';

export class Constants {
  // Patterns
  static readonly alphabetPattern: string = VALIDATION_PATTERNS.name.source;
  static readonly emailPattern: RegExp = VALIDATION_PATTERNS.email;
  static readonly phonePattern: string = VALIDATION_PATTERNS.phone.source;
  static readonly passwordPattern: RegExp = VALIDATION_PATTERNS.password;

  // Constants
  static readonly minAge: number = 18;
  static readonly maxAge: number = 99;
  static readonly minNicotine: number = 1;
  static readonly minOxygen: number = 1;

  static readonly diagnosisOptions = [
    'Asthma',
    'Bronchitis',
    'COPD-1',
    'COPD-2',
    'COPD-3',
    'COPD-4',
    'COVID',
  ];

  static readonly inhalationOptions = ['Spray', 'Pulver', 'Feucht'];

  static readonly employmentTypeOptions = [
    'sittingActivity',
    'frontScreen',
    'office',
    'homeOffice',
    'car',
    'standingActivity',
  ];

  static readonly activeSportsOptions = [
    'jogging',
    'muscleTraining',
    'yoga',
    'lungSport',
    'other',
  ];
}
